import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import get from 'lodash/get';

import { FormItem } from '@skunexus/component-catalog';
import { constants, Magento2FormPartComponents } from '@skunexus/integration-form';

import { useMagento2FormPart } from './useMagento2FormPart';
import WebsitesFields from './components/WebsitesFields';
import MSIFields from './components/MSIFields';

const { OrdersWebhook } = Magento2FormPartComponents;

function Magento2FormPart(props) {
    const { details, errorNotification, formData } = props;

    const { dictionaries, isLoading, useMsi, setUseMsi } = useMagento2FormPart({
        formData,
        details,
        errorNotification,
    });

    return (
        <Row>
            <Col xs={12} sm={6}>
                <FormItem
                    label="Cancel and Refund"
                    name="settings.cancel_and_refund"
                    type="dropdown"
                    value={get(formData, 'settings.cancel_and_refund', 0)}
                    options={constants.CANCEL_AND_REFUND_OPTIONS}
                    validate={{}}
                />
            </Col>
            <Col xs={12} sm={6}>
                <FormItem
                    label="Notify Refund"
                    name="settings.notify_cancel_refund"
                    type="dropdown"
                    value={get(formData, 'settings.notify_cancel_refund', 1)}
                    options={constants.YES_NO_OPTIONS}
                    validate={{ required: { value: true } }}
                />
            </Col>
            <Col xs={12}>
                <FormItem
                    label="Order Statuses Required"
                    name="settings.orders_statuses_required"
                    type="tags"
                    value={get(formData, 'settings.orders_statuses_required', '')}
                    validate={{}}
                    tagsProps={{
                        placeHolder: 'Enter statuses',
                        info: 'Press enter to add new status',
                    }}
                />
            </Col>
            <Col xs={12} sm={6}>
                <FormItem
                    label="Order update at"
                    name="settings.orders_updated_at"
                    type="datetime"
                    value={get(formData, 'settings.orders_updated_at', '')}
                    validate={{}}
                />
            </Col>
            <Col xs={12} sm={6}>
                <FormItem
                    label="Product update at"
                    name="settings.products_updated_at"
                    type="datetime"
                    value={get(formData, 'settings.products_updated_at', '')}
                    validate={{}}
                />
            </Col>
            <Col xs={12}>
                <FormItem
                    label="Access Token"
                    name="settings.access_token"
                    value={get(formData, 'settings.access_token', '')}
                    validate={{ required: { value: true } }}
                />
            </Col>
            <Col xs={12}>
                <FormItem
                    label="Store base url"
                    name="settings.store_base_url"
                    value={get(formData, 'settings.store_base_url', '')}
                    validate={{ required: { value: true } }}
                />
            </Col>
            <Col xs={12}>
                <FormItem
                    label="Custom User Agent"
                    name="settings.custom_user_agent"
                    value={get(formData, 'settings.custom_user_agent', '')}
                />
            </Col>
            <Col xs={12}>
                <FormItem
                    label="Connection Integration prefix"
                    name="settings.connection_integration_prefix"
                    value={get(formData, 'settings.connection_integration_prefix', '')}
                />
            </Col>
            <Col xs={12}>
                <OrdersWebhook {...props} />
            </Col>
            <Col xs={12}>
                <WebsitesFields {...props} dictionaries={dictionaries} isLoading={isLoading} />
            </Col>
            <Col xs={12} className="mt-3">
                <FormItem
                    label="Use MSI"
                    name="settings.inventory_uses_msi"
                    type="checkbox"
                    value={useMsi}
                    onChange={(e, value) => setUseMsi(value)}
                />
            </Col>
            {useMsi && (
                <Col xs={12}>
                    <MSIFields {...props} dictionaries={dictionaries} isLoading={isLoading} />
                </Col>
            )}
        </Row>
    );
}

Magento2FormPart.propTypes = {
    details: PropTypes.object,
    formData: PropTypes.object,
    dictionaries: PropTypes.object,
    onChangeField: PropTypes.func.isRequired,
    errorNotification: PropTypes.func.isRequired,
};
Magento2FormPart.defaultProps = {
    details: {},
    formData: {},
    dictionaries: {},
};

export default Magento2FormPart;
